import { createAxiosHttpClient } from '@/shared/features/query/infra/adapters/axios.adapter';

export type OtpDeliveryMode = 'text' | 'call';

const httpClient = createAxiosHttpClient();
export interface AccountDetails {
  activeGRPPlans: number;
  blueCredit: number;
  blueCash: number;
  orderCount: number;
  activeGMSPlans: number;
  isAllowedToDiscard: boolean;
  voucherCount: number;
}

export interface AccountMergingResponse {
  customerPhone: string;
  customerAccountsData: Record<string, AccountDetails>;
  hasError: boolean;
  message: string;
}

export async function fetchAccountMergingCustomers(): Promise<AccountMergingResponse> {

  const response = await httpClient.request<AccountMergingResponse>({
    url: '/account-merging/get-customers-data',
    method: 'GET',
    withCredentials: true,
  });

  return response.data;
}






export interface GenerateOtpResponse {
  hasError: boolean;
  message: string;
  otpId?: number;
}

export async function generateOtpForVerification(
  contactDetail: string, 
  isVerificationBeforeMerging: boolean
): Promise<GenerateOtpResponse> {

  const body = new URLSearchParams({
    contactDetail,
    isVerificationBeforeMerging: String(isVerificationBeforeMerging),
  });

  const response = await httpClient.request<GenerateOtpResponse>({
    url: '/account-merging/generate-otp-for-contact-verification',
    method: 'POST',
    data: body,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    withCredentials: true,
  });

  return response.data;
}




export async function resendOtpForVerification(
  contactDetail: string,
  otpId: number,
  isVerificationBeforeMerging: boolean,
  otpDeliveryMode?: OtpDeliveryMode
): Promise<GenerateOtpResponse> {

  const body = new URLSearchParams({
    contactDetail,
    otpId: String(otpId),
    isVerificationBeforeMerging: String(isVerificationBeforeMerging),
  });

  if (otpDeliveryMode) {
    body.append('otpDeliveryMode', otpDeliveryMode);
  }

  const response = await httpClient.request<GenerateOtpResponse>({
    url: '/account-merging/resend-otp',
    method: 'POST',
    data: body,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    withCredentials: true,
  });

  return response.data;
}


export async function verifyContactDetail(
  contactDetail: string,
  otpId: number,
  otpString: string,
  isVerificationBeforeMerging: boolean
): Promise<{ hasError: boolean; message: string }> {

  const body = new URLSearchParams({
    contactDetail,
    otpId: String(otpId),
    otpString,
    isVerificationBeforeMerging: String(isVerificationBeforeMerging),
  });

  const response = await httpClient.request<{ hasError: boolean; message: string }>({
    url: '/account-merging/verify-contact-detail',
    method: 'POST',
    data: body,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    withCredentials: true,
  });

  return response.data;
}





export interface AccountMergingPayload {
  primaryAccountEmail: string;
  accountsToBeDiscarded: string[];
  accountsToBeMerged: string[];
  accountsToBeTransferred: Array<{ email: string; newPhoneNumber: string; otpId: number }>;
}

export async function processAccountMerging(payload: AccountMergingPayload): Promise<{ 
  hasError: boolean; 
  message: string; 
  isLogoutRequired?: boolean;
}> {

  const response = await httpClient.request<{ hasError: boolean; message: string; isLogoutRequired?: boolean }>({
    url: '/account-merging/process-accounts',
    method: 'POST',
    data: payload,
    headers: {
      'Content-Type': 'application/json',
    },
    withCredentials: true,
  });

  return response.data;
}